import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import createClient from './apollo/client';
import { ApolloProvider } from '@apollo/client';
import { getEnvConfig, getTeamConfig } from './config/config';
import Index from './pages/index';
import RosterPage from './pages/roster/rosterPage';
import Scorecard from './pages/scorecard';
import Player from './pages/player';
import styles from './App.module.scss';
import './styles/overrides.scss';
import { ActiveFiltersProvider } from './context/active-filter-context';

const App: React.FC = () => {
  const client = createClient();
  const thisTeam = getTeamConfig();
  const root = getEnvConfig().root;
  const roster = getEnvConfig().root + '/Roster';
  const scorecard = getEnvConfig().root + '/scorecard/:id';
  const player = getEnvConfig().root + '/player/:id';

  return (
    <Router>
      <div className={styles.page}>
        <div className={styles.content}>
          <ApolloProvider client={client}>
            <ActiveFiltersProvider>
              <Routes>
                <Route path={root} element={<Index />} />
                {thisTeam.playersModule === true ? (
                  <Route path={roster} element={<RosterPage />} />
                ) : null}
                <Route path={scorecard} element={<Scorecard />} />
                <Route path={player} element={<Player />} />
              </Routes>
            </ActiveFiltersProvider>
          </ApolloProvider>
        </div>
      </div>
    </Router>
  );
};

export default App;
